import { useLocation, useNavigate } from 'react-router-dom';
import { removeBreadCrumbs } from '../redux/commonSlice';

interface Props {
  breadcrums?: {
    url?: any;
    name: string;
    index?: number;
    /** When set, runs instead of navigating (e.g. close overlay / reset wizard). */
    onBreadcrumbClick?: () => void;
  }[];
}

/**
 * Renders a nested breadcrumb list with navigation functionality.
 * @example
 * BreadcrumNested({ breadcrums: [{ name: 'Home', url: '/' }, { name: 'About', url: '/about' }] })
 * <ul className="breadCrums nested"><li>Home</li><li>About</li></ul>
 * @param {Props} props - The props containing breadcrumb data.
 * @returns {JSX.Element} JSX element representing the breadcrumb list.
 * @description
 *   - The function relies on react-router-dom's useNavigate for navigation.
 *   - Breadcrumbs without a URL will not have click functionality.
 */
export default function BreadcrumNested(props: Props) {
  const { breadcrums } = props;
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <ul className="breadCrumbs nested">
      {breadcrums &&
        breadcrums.map((v: any, i: number) => {
          return (
            <li
              key={`${v.name}-${i}`}
              onClick={() => {
                if (v.onBreadcrumbClick) {
                  v.onBreadcrumbClick();
                  return;
                }
                if (v.url) {
                  if (v.url === '/') {
                    removeBreadCrumbs();
                  }
                  navigate(v.url, {
                    state: {
                      ...state,
                      breadCrumbs:
                        state && state?.breadCrumbs
                          ? state?.breadCrumbs?.slice(0, v?.index)
                          : null,
                    },
                  });
                }
              }}
            >
              {v.name}
            </li>
          );
        })}
    </ul>
  );
}
